/** Canonical image URLs shared by social metadata and structured data. */
const SITE_ORIGIN = 'https://backyahdbbq.com';
const MEDIA_ORIGIN = 'https://media.backyahdbbq.com';
const SITE_MEDIA_PREFIXES = [
  'media/blog/horizon-weber-offset/v',
  'media/blog/new-freezer-meat-n-bone/',
  'media/blog/wagyu-tomahawk-reverse-sear/',
  'blog-drafts/new-freezer-meat-n-bone/',
];

export function getSeoImageUrl(value: string | undefined): string | undefined {
  if (!value) return undefined;
  if (/^https?:\/\//i.test(value)) return value;
  const pathname = value.replace(/^\//, '');
  if (
    pathname.startsWith('media/') &&
    !SITE_MEDIA_PREFIXES.some((prefix) => pathname.startsWith(prefix))
  ) {
    return new URL(pathname, MEDIA_ORIGIN + '/').href;
  }
  return new URL('/' + pathname, SITE_ORIGIN).href;
}
